module.exports = __webpack_public_path__ + "assets/img/5_1151_big.8a292ca3.jpg";